import axios, { AxiosResponse } from 'axios'

import { toastify } from 'components/Toast'

/**
 * Axios instance to call /api endpoints
 */
const axiosApi = axios.create({
  baseURL: '/api',
  withCredentials: true,
})

axiosApi.defaults.headers.common['Content-Type'] = 'application/json'
axiosApi.defaults.headers.common['Accept'] = 'application/json'

axiosApi.interceptors.response.use(
  (response: AxiosResponse) => {
    // Return a successful response back to the calling service
    return response
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (err: any) => {
    if (err.response.status === 429) {
      toastify.dismiss()
      toastify.error({
        title: 'Oops! Too many requests',
        description: 'Please wait a minute and try again',
      })
    } else if (err.response.status === 401) {
      toastify.dismiss()
      toastify.warning({
        title: 'Reconnect your wallet',
        description: 'Please connect your wallet again',
      })
    }
    return Promise.reject(err)
  }
)

export default axiosApi
